module.exports = __webpack_public_path__ + "img/5055ed7.jpg";